import { SortingState } from "@tanstack/react-table";
import TableContainer2 from "Common/Tables/ObjectFiltersTable/TableContainer2";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import LoaderErrorWrapper from "components/LoaderErrorWrapper/LoaderErrorWrapper";
import PageContainer from "components/PageContainer/PageContainer";
import BagQRPrint from "pages/Warehouse/ItemInward2/GRNDetails/BagQRPrint/BagQRPrint";
import { useEffect, useMemo, useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { createSelector } from "reselect";
import { fetchInStockViewDetails } from "slices/Warehouse/ProjectWarehouse/InStock/ViewDetails/thunk";

const InStockViewDetails: any = () => {
  document.title = "In Stock View";
  const dispatch = useDispatch<any>();
  const { master_item_id, warehouse_id } = useParams();
  const navigate = useNavigate();
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showQRPrint, setShowQRPrint] = useState<boolean>(false);
  const [qrPrintItem, setQrPrintItem] = useState<any>(null);
  const [columnFilters, setColumnFilters] = useState<any>();
  const [sorting, setSorting] = useState<SortingState>([]);
  const [searchInput, setSearchInput] = useState("");
  const [search, setSearch] = useState("");
  const [filterValue, setFilterValue] = useState<any[]>([]);
  const [warehouseName, setWarehouseName] = useState<string>("Warehouse");
  const sortField = sorting[0]?.id ?? "";
  const sortDirection = sorting[0]?.desc ? "desc" : "asc";

  //    const isFirstRender = useRef(true);
  //    const memoizedSorting = useMemo(() => sorting, [sorting]);
  //    const memoizedFilterValue = useMemo(() => filterValue, [filterValue]);

  const selectDraftRfqs = createSelector(
    (state: any) => state.DailyLogViewDetailsReducer,
    (data) => ({
      list: data.list,
      rowCount: data.rowCount,
      loading: data.loading,
      error: data.error,
    })
  );
  const { list, rowCount, loading, error } = useSelector(selectDraftRfqs);

  useEffect(() => {
    // if (master_item_id && warehouse_id) {
    if (master_item_id && warehouse_id) {
      dispatch(
        fetchInStockViewDetails({
          page: pageIndex + 1,
          pageSize,
          sort: sortField,
          order: sortField ? (sortDirection as "asc" | "desc") : "",
          search,
          filters: filterValue,
          warehouse_id: warehouse_id,
          master_item_id,
        })
      );
    }
  }, [
    dispatch,
    pageIndex,
    pageSize,
    sorting,
    search,
    filterValue,
    warehouse_id,
    master_item_id,
  ]);

  // Extract warehouse name and type from the data
  useEffect(() => {
    if (loading) {
      setWarehouseName("Warehouse");
    } else if (list && list.length > 0) {
      const firstItem = list[0];
      if (firstItem?.inventory?.warehouse?.warehouse_name) {
        const warehouseName = firstItem.inventory.warehouse.warehouse_name;
        const warehouseType = firstItem.inventory.warehouse.warehouse_type;
        const displayName = warehouseType
          ? `${warehouseName} (${warehouseType})`
          : warehouseName;
        setWarehouseName(displayName);
      }
    }
  }, [list, loading]);
  //*//
  const handlePrintQR = (item: any) => {
    setQrPrintItem(item);
    setShowQRPrint(true);
  };

  const columns = useMemo(() => {
    return [
      {
        header: "Sr. No.",
        id: "sr_no",
        enableSorting: false,
        enableColumnFilter: false,
        cell: ({ row }: { row: any }) => {
          return row.index + 1 + pageIndex * pageSize;
        },
      },
      {
        header: "Item Name",
        accessorKey: "master_item.item_name",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: "/package/dropdown/package_name",
        cell: ({ row }: { row: any }) => {
          return row.original?.master_item?.item_name;
        },
      },
      {
        header: "Unit",
        accessorKey: "unit",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: "/package/dropdown/package_code",
        cell: ({ row }: { row: any }) => {
          return row.original?.master_item?.unit?.unit_name;
        },
      },

      {
        header: "Bag No.",
        accessorKey: "bag_no",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: `/item_inward/dropdown_column/?column=bag_no`,
        cell: ({ row }: { row: any }) => {
          return row.original?.bag_no;
        },
      },
      {
        header: "Received Quantity",
        accessorKey: "quantity",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: "/package/dropdown/package_code",
        cell: ({ row }: { row: any }) => {
          return row.original?.quantity;
        },
      },
      {
        header: "Available Quantity",
        accessorKey: "available_quantity",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: "/package/dropdown/package_code",
        cell: ({ row }: { row: any }) => {
          return row.original?.available_quantity;
        },
      },
      {
        header: "Reserved Quantity",
        accessorKey: "reserved_quantity",
        enableColumnFilter: false,
        enableSorting: false,
        filterType: "dropdown" as const,
        filterFetchUrl: "/package/dropdown/package_code",
        cell: ({ row }: { row: any }) => {
          return row.original?.reserved_quantity;
        },
      },

      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: ({ row }: { row: any }) => {
          const inventoryItemId =
            row.original?.id || row.original?.inventory_item_id;
          return (
            <ul className="d-flex gap-2 list-unstyled mb-0">
              <li>
                <Button
                  onClick={() => inventoryItemId && handlePrintQR(row.original)}
                  className="btn btn-primary btn-sm"
                  disabled={!inventoryItemId}
                >
                  Print QR
                </Button>
              </li>
            </ul>
          );
        },
      },
    ];
  }, [dispatch]);
  return (
    <PageContainer>
      <Card className="m-0 p-0">
        <Card.Header className="m-0 p-0">
          <FormHeader
            title="Item Details - Item"
            firstLabel={warehouseName}
            secondLabel="Item Details - Item"
            handleArrowClick={() => navigate("/dispatch/warehouse-overview")}
            handleBreadcrumbClick={() =>
              navigate("/dispatch/warehouse-overview")
            }
          />
        </Card.Header>
        <Card.Body>
          <LoaderErrorWrapper loading={loading} error={error}>
            <TableContainer2
              columns={columns}
              data={list || []}
              totalRecords={rowCount}
              pageIndex={pageIndex}
              pageSize={pageSize}
              onPageChange={setPageIndex}
              onPageSizeChange={setPageSize}
              columnFilters={columnFilters}
              setColumnFilters={setColumnFilters}
              colValue={setFilterValue}
              sorting={sorting}
              onSortingChange={setSorting}
              isBordered={false}
              isPagination={true}
              isGlobalFilter={false}
              SearchPlaceholder="Search Items..."
              manualSorting={true}
            />
          </LoaderErrorWrapper>
        </Card.Body>
      </Card>

      <BagQRPrint
        show={showQRPrint}
        handleClose={() => {
          setShowQRPrint(false);
          setQrPrintItem(null);
        }}
        inventoryItemId={
          qrPrintItem?.id || qrPrintItem?.inventory_item_id || ""
        }
        bagNo={qrPrintItem?.bag_no || ""}
        autoPrint={true}
      />
    </PageContainer>
  );
};

export default InStockViewDetails;
